"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./Header.styles"));
exports.default = (props) => {
    const { title, left, right, onPressBack, onPressClear, leftIcon, transparent, children, } = props;
    return (react_1.default.createElement(S.HeaderContainer, null,
        react_1.default.createElement(S.Card, { transparent: transparent },
            leftIcon ? (react_1.default.createElement(S.ButtonIcon, { accessibilityLabel: "close", accessibilityHint: "close window", accessibilityRole: "button", onPress: onPressBack, testID: "BackPressIcon" }, leftIcon)) : (react_1.default.createElement(S.Button, { onPress: onPressBack, testID: "BackPress" },
                react_1.default.createElement(S.CardLeftText, null, left))),
            react_1.default.createElement(S.CardTitleText, { transparent: transparent }, title),
            react_1.default.createElement(S.Button, { onPress: onPressClear, testID: "ClearPress" },
                react_1.default.createElement(S.CardRightText, null, right))),
        children && react_1.default.createElement(S.Container, null, children)));
};
